export default __webpack_public_path__ + "static/media/icon.63cd7775.jpeg";